import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';

import {BaseComponent} from "@shared/components/base-component";
import {NewDataStoreService} from "@shared/services/new-data-store.service";

import {HandoverHttpService} from "@handover/http-services/handover-http.service";
import {VehicleListItem} from "@handover/view-models/vehicle-list-item";
import {
  FilterType,
  HandoverNotificationsService
} from "@handover/routes/main-route/services/handover-notifications.service";
import { VehicleService } from '@commons/services/vehicle/vehicle.service';

import { map, filter, Subscription } from 'rxjs';
import { isEqual } from 'lodash';

@Component({
  selector: 'handovermod-vehicles-list',
  templateUrl: './vehicles-list.component.html',
  styleUrls: ['./vehicles-list.component.less'],
})
export class VehiclesListComponent extends BaseComponent implements OnInit, OnDestroy {

  filteredVehicles?: VehicleListItem[];
  allVehicles?: VehicleListItem[];
  selectedVehicleId?: number;
  isLoading = true;

  private filterText = '';
  private filterStatus = 0;

  private vehiclesIds: number[] = [];

  private getVehiclesSubsc: Subscription;

  constructor(
    private handoverHttpService: HandoverHttpService,
    private handoverNotificationsService: HandoverNotificationsService,
    private newDataStoreService: NewDataStoreService,
    private vehicleService: VehicleService,
    private zone: NgZone,
  ) {
    super();
    this.subToFilterChanged();
  }

  ngOnInit(): void {
    this.getVehicles();
  }

  ngOnDestroy(): void {
    this.getVehiclesSubsc?.unsubscribe();
  }

  private getVehicles(): void {
    this.zone.run(() => {
      this.getVehiclesSubsc = this.vehicleService.getList$().pipe(
        map(data => data.map(item => item.Id)),
        filter(data => !isEqual(data, this.vehiclesIds)),
      )
      .subscribe(ids => {
        this.vehiclesIds = [...ids];
        this.getHandoversVehicle();
      });
    });
  }

  private getHandoversVehicle(ids: number[] = this.vehiclesIds): void {
    this.handoverHttpService.getVehicles(ids).subscribe(result => {
      this.setVehiclesNames(result);
      this.setVehiclesDrivers(result);
      this.filteredVehicles = this.allVehicles = result;
      this.isLoading = false;
    });
  }

  isItemSelected(vehicle: VehicleListItem): boolean {
    return this.selectedVehicleId === vehicle.vehicleId;
  }

  onSelect(vehicle?: VehicleListItem) {
    if (vehicle?.vehicleId !== this.selectedVehicleId) {
      this.selectedVehicleId = vehicle?.vehicleId;
      this.handoverNotificationsService.selectedVehicleChanged$.next(vehicle);
      this.handoverNotificationsService.selectedHandoverChanged$.next(undefined);
    }
  }

  private setVehiclesDrivers(items: VehicleListItem[]) {
    const drivers = this.newDataStoreService.getDrivers();
    items?.forEach(v => {
      if (v.driverId) {
        const driver = drivers.find(d => d.Id === v.driverId);
        if (driver)
          v.driverFullName = `${driver.FN} ${driver.LN}`;
        else
          console.error('No driver for id=' + v.driverId);
      }
    });
  }

  private setVehiclesNames(items: VehicleListItem[]) {
    const vehicles = this.newDataStoreService.getVehicles();
    items?.forEach(v => {
      const matched = vehicles.find(d => d.Id === v.vehicleId);
      if (matched)
        v.vehicleName = matched.Nm;
      else
        console.error('No vehicle for id=' + v.vehicleId);
    });
  }

  private filterList() {
    this.onSelect(undefined);
    this.filteredVehicles = this.allVehicles?.filter(v => {
      const result = this.textFilter(v) && this.statusFilter(v);
      return result;
    });
  }

  private textFilter(v: VehicleListItem): boolean {
    let result = false;
    if (this.filterText) {
      result = v.vehicleName?.toLowerCase().includes(this.filterText) || v.driverFullName?.toLowerCase().includes(this.filterText);
    } else {
      result = true;
    }
    return result;
  }

  private statusFilter(v: VehicleListItem): boolean {
    let result = false;
    if (this.filterStatus) {
      switch (this.filterStatus) {
        case FilterType.All:
          result = true;
          break;

        case FilterType.Available:
          result = v.isAvailable === true;
          break;

        case FilterType.Given:
          result = v.isAvailable === false;
          break;

        default:
          console.error(`Not supported status=${this.filterStatus}`);
      }
    } else {
      result = true;
    }
    return result;
  }

  private subToFilterChanged() {
    this.addToUnsubscribe(
      this.handoverNotificationsService.filterTextChangeSubject$.subscribe(text => {
        this.filterText = text;
        this.filterList();
      }));

    this.addToUnsubscribe(
      this.handoverNotificationsService.filterStatusChangeSubject$.subscribe(status => {
        this.filterStatus = status;
        this.filterList();
      }));
  }

}
